import React, { useState } from "react";
import "../styling/SignUp.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BookingHeader from "./clientPortal/BookingHeader";
const SignUp = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  // };

  const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevState) => ({
    ...prevState,
    [name]: name === 'email' ? value.toLowerCase() : value,
  }));
};


  

  // const handleSubmit = () => {
  //   // Send formData to your API
  //   console.log('Sending formData:', formData);
  //   // Example fetch request to send formData to an API
  //   fetch('https://example.com/api/submit', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(formData)
  //   })
  //   .then(response => {
  //     if (response.ok) {
  //       console.log('Form data submitted successfully');
  //     } else {
  //       console.error('Failed to submit form data');
  //     }
  //   })
  //   .catch(error => {
  //     console.error('Error submitting form data:', error);
  //   });
  // };

  const handleNext = async () => {
    // Basic validation
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone) {
      alert("Please fill in all fields");
      return;
    }

    try {
      console.log("Checking if user exists with email:", formData.email);

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/user-exists`,
        { email: formData.email },
        { withCredentials: true }
      );

      console.log("API Response:", res.data);

      const { status } = res.data.data;

      if (status === "not_found") {
        console.log("User not found. Proceeding to password step.");
        navigate("/password", { state: formData });
      } else if (status === "verified") {
        alert("This email is already registered. Please log in.");
        navigate("/login");
      } else if (status === "resent") {
        alert(
          "This email is already registered. Please follow the steps to verify your account."
        );
        navigate("/checkMail");
      } else {
        console.warn("Unexpected status received:", status);
      }
    } catch (err) {
      console.error("Error checking user existence:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div>
      <BookingHeader />
      <div className="login-page-container">
        <div className="login-business">
          <div className="login-content">
          <h1
            style={{
              fontSize: "24px",
              color: "#000000",
              textAlign: "center",
              display: "block",
              fontWeight: "bold",
              marginTop: "60px",
              marginBottom: "5px",
            }}
          >
            Try BoothBloom free for 7 days
          </h1>
          <div style={{ paddingLeft: "1%", color: "#625C73" }}>
            <p style={{ marginTop: "0px", fontSize: "15px" }}>
              No Credit Card Required
            </p>
          </div>
          <div style={{ width: "95%" }}>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              className="login-input"
              value={formData.firstName}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              className="login-input"
              value={formData.lastName}
              onChange={handleInputChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              step={{ fontColor: "#000000" }}
              className="login-input"
              value={formData.email}
              onChange={handleInputChange}
            />
             <input
              type="phone"
              name="phone"
              placeholder="Phone"
              step={{ fontColor: "#000000" }}
              className="login-input"
              value={formData.phone}
              onChange={handleInputChange}
            />
            <button
              className="login-button"
              style={{ width: "103.5%" }}
              onClick={handleNext}
            >
              Next &gt;
            </button>
          </div>

          <div
            style={{
              paddingLeft: "1%",
              color: "#545454",
              fontSize: "12px",
              marginTop: "30px",
              marginBottom: "70px",
            }}
          >
            <p>
              {" "}
              Go Back to{" "}
              <Link to="/login">
                <span style={{ textDecoration: "underline", color: "#545454" }}>
                  login page
                </span>
              </Link>{" "}
            </p>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
